/**
 * Converts a duration in minutes to a human-readable string.
 * e.g. 15 → "15 mins", 60 → "1 hour", 90 → "1 hour 30 mins", 210 → "3 hours 30 mins"
 */
export const formatDuration = (minutes) => {
  if (!minutes && minutes !== 0) return 'N/A';
  const mins = Number(minutes);
  if (mins < 60) return `${mins} mins`;
  const hours = Math.floor(mins / 60);
  const remainder = mins % 60;
  const hourLabel = hours === 1 ? '1 hour' : `${hours} hours`;
  if (remainder === 0) return hourLabel;
  return `${hourLabel} ${remainder} mins`;
};
